// extracted by mini-css-extract-plugin
export default {"teacher":"TeacherDivisor_teacher__1VIsc","text":"TeacherDivisor_text__58mJM","image":"TeacherDivisor_image__GaYFh","rounded":"TeacherDivisor_rounded__8hL9Q"};